/* eslint-disable arrow-body-style */
/* eslint-disable operator-linebreak */
import React, { useEffect, useState } from 'react';
import { TextField, Button, Tooltip, Autocomplete } from '@mui/material';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { useForm, useFieldArray } from 'react-hook-form';
import CreateProduct from '../../Modal/CreateProduct';

import { AddSerialNumberDialog, AddOptionDialog } from '../../Dialogs';

import { SPM } from '../../../utils/Proptypes';

const resetValues = {
  // product: null,
  // price: '',
  amount: '',
  // project_number: '',
  // cost_price1: '',
  // cost_price: '',
};

export const AddProductFormMany = ({
  errors,
  Controller,
  product,
  filterProduct,
  setFilterProduct,
  productList,
  setProductList,
  setReload,
  reload,
  selectWarehouse,
}) => {
  const [isModalCreateProductOpen, setIsModalCreateProductOpen] = useState(
    false,
  );
  const handleOpen = () => setIsModalCreateProductOpen(true);
  const handleClose = () => {
    setIsModalCreateProductOpen(false);
  };
  const { getValues, control, reset } = useForm({
    mode: 'onBlur',
  });

  const NewProduct = _.map(product, (_product, index) => ({
    index: index + 1,
    ..._product,
  }));

  const checkProduct = (data) => {
    // eslint-disable-next-line no-underscore-dangle
    const findproduct = _.find(product, { id: data?._id });
    setFilterProduct(findproduct);
  };
  console.log("checkProduct", checkProduct());

  useEffect(() => () => { }, [reload]);
  const handleScanBarcode = (barcode) => {
    if (!selectWarehouse) {
      alert('กรุณาเลือกคลังสินค้า');
      return;
    }

    // ค้นหาสินค้าในรายการ
    const foundProduct = NewProduct.find(
      (item) => item.type_code === barcode
    );
    console.log("foundProduct", foundProduct);
    if (!foundProduct) {
      alert('ไม่พบสินค้าที่สแกน');
      return;
    }
    const index = productList.findIndex(
      (p) =>
        p.product._id === foundProduct._id &&
        p.warehouse._id === selectWarehouse._id &&
        p.project_number === getValues('project_number') &&
        p.serialNumber === getValues('serialNumber')
    );
    let updatedList = [...productList];
    console.log("updatedList", updatedList);

    if (index > -1) {
      updatedList[index].amount =
        parseInt(updatedList[index].amount || 1) + 1;
    } else {
      updatedList.push({
        product: foundProduct,
        amount: 1,
        serialNumber: '',
        warehouse: selectWarehouse,
        project_number: getValues('project_number'),
        serialNumber: getValues('serialNumber'),
      });
    }
    setProductList(updatedList);
    // reset(resetValues);
    setReload(!reload);
  };
  return (
    <div>
      <CreateProduct
        isOpen={isModalCreateProductOpen}
        handleOnClose={handleClose}
      />
      <div className="flex flex-row flex-wrap">
        <div className="w-full px-1 py-2 flex ">
          <input
            className="border border-gray-300 rounded px-3 py-2 w-full"
            placeholder="ยิงบาร์โค้ดสินค้า"
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                const barcode = event.target.value.trim();
                if (barcode) {
                  handleScanBarcode(barcode);
                  event.target.value = ''; // เคลียร์ค่าหลังสแกน
                }
              }
            }}
          />
          <div className="my-auto pl-1  flex-none">
            <Tooltip
              title="เพิ่มสินค้ากรณีที่ยังไม่มีข้อมูลในระบบ"
              placement="bottom"
            >
              <Button variant="outlined" onClick={handleOpen}>
                เพิ่มสินค้า
              </Button>
            </Tooltip>
          </div>
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'project_number'}
            control={control}
            defaultValue={''}
            rules={{ required: false }}
            render={({ field }) => (
              <TextField
                {...field}
                label="รหัสโครงการ"
                fullWidth
                size={'small'}
                disabled={!selectWarehouse}
                helperText={errors.remark && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>
        <div className="w-full px-1 py-1">
          <Controller
            name={'serialNumber'}
            control={control}
            defaultValue={''}
            rules={{ required: false }}
            render={({ field }) => (
              <TextField
                {...field}
                label="หมายเลขซีเรียล"
                fullWidth
                size={'small'}
                disabled={!selectWarehouse}
                helperText={errors.remark && 'กรุณาใส่ข้อมูล'}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

AddProductFormMany.propTypes = {
  errors: PropTypes.shape({
    product_transaction_type: PropTypes.object,
    orderNumber: PropTypes.billNumber,
    customer: PropTypes.array,
    source: PropTypes.object,
    quantity: PropTypes.object,
    price: PropTypes.object,
    product_stock_lots: PropTypes.object,
    warehouse: PropTypes.object,
    product_type: PropTypes.array,
    productionDate: PropTypes.object,
    expirationDate: PropTypes.object,
    receiptDate: PropTypes.object,
    sellDate: PropTypes.object,
    remark: PropTypes.object,
    recipientName: PropTypes.object,
    sellName: PropTypes.object,
    trackingNumber: PropTypes.object,
    sellPrice: PropTypes.object,
    shippingCost: PropTypes.object,
    discount: PropTypes.object,
    payment: PropTypes.payment,
  }),
  product: PropTypes.array,
  productType: PropTypes.array,
  productTransactionType: PropTypes.array,
  order: PropTypes.oneOf([SPM.Order, SPM.OrderArray]),
  Controller: PropTypes.func,
  control: PropTypes.object,
  type: PropTypes.object,
  setType: PropTypes.func,
  selectProduct: PropTypes.array,
  setSelectProduct: PropTypes.func,
  filterProduct: PropTypes.object,
  setFilterProduct: PropTypes.func,
  customers: PropTypes.array,
  departments: PropTypes.object,
  watch: PropTypes.func.isRequired,
  products: PropTypes.object,
  selectedProducts: PropTypes.array,
  setSelectedProducts: PropTypes.func,
  employees: PropTypes.array,
  productTypes: PropTypes.object,
  productList: PropTypes.array,
  setProductList: PropTypes.func,
  reload: PropTypes.bool,
  setReload: PropTypes.func,
  selectSerial: PropTypes.array,
  setSelectSerial: PropTypes.func,
  selectOption: PropTypes.array,
  setSelectOption: PropTypes.func,
  selectWarehouse: PropTypes.object,
};

AddProductFormMany.defaultProps = {
  product: null,
  productType: null,
  productTransactionType: null,
  customer: null,
  department: null,
  me: null,
  type: null,
  selectProduct: null,
  filterProduct: null,
};

export default AddProductFormMany;
